import { ICreateTicket } from '@/@Interfaces/CreateTicket';
import { post } from './api';
import URLS from '@/constants/api';
// ICreateTicket
export const createTicket = async (ticketData: any) => {
  const response = await post(URLS.TICKETS, ticketData);
  return response;
};
